import { Box, Collapse, Divider, Text } from "@mantine/core";
import { IconChevronDown, IconChevronUp } from "@tabler/icons-react";
import { useState } from "react";

function CollapsibleHeader({ header, defaultState = false, children }) {
    const [isToggled, setIsToggled] = useState(defaultState)

    return (
        <Box style={{ 
            margin: "12px 0px",
            border: "1px solid var(--divider-border-color)",
            borderRadius: "6px"
         }}>
            <Box style={{
                display: "inline-flex",
                width: "100%",
                padding: "12px",
                borderRadius: "3px",
                cursor: "pointer"
            }}
                onClick={() => setIsToggled(!isToggled)}>
                <Text w={"100%"}>{header}</Text>
                {isToggled ? <IconChevronUp /> : <IconChevronDown />}
            </Box>

            <Collapse expanded={isToggled} p={"sm"}>
                <Divider />
                {children}
            </Collapse>
        </Box>
    )
}

export default CollapsibleHeader;